// extracted by mini-css-extract-plugin
module.exports = {"root":"WishlistButton_root__crSyc","icon":"WishlistButton_icon__J690_","loading":"WishlistButton_loading__BcgF9","inWishlist":"WishlistButton_inWishlist__uwrZI"};